// extracted by mini-css-extract-plugin
export const backgroundImage = "SpecialVoyageInfoSummary-module--background-image--aycIu";
export const header = "SpecialVoyageInfoSummary-module--header--FLMMk";
export const footer = "SpecialVoyageInfoSummary-module--footer--3lBUl";
export const box = "SpecialVoyageInfoSummary-module--box---QmVD";
export const infoContainer = "SpecialVoyageInfoSummary-module--info-container--1kbpo";
export const destinationName = "SpecialVoyageInfoSummary-module--destination-name--_KVKj";
export const cruiseName = "SpecialVoyageInfoSummary-module--cruise-name--hdcRM";
export const price = "SpecialVoyageInfoSummary-module--price--15XyO";
export const disclaimer = "SpecialVoyageInfoSummary-module--disclaimer--3-fNO";
export const ctaButtons = "SpecialVoyageInfoSummary-module--cta-buttons--lfJ43";
export const cta = "SpecialVoyageInfoSummary-module--cta--11RUU";